import {
    SmallTextHelper
} from '../PrismicHelpers';

export const forumPageHelper = (response) => {
    const forumData = response.result;
    let forumObject = forumData.map(forum => {
        return {
            uid: SmallTextHelper(forum.id),
            forum_title: SmallTextHelper(forum.data.forum_page_title),
            forum_summary: SmallTextHelper(forum.data.forum_summary),
        }
    })
    return forumObject;
}


// WEBPACK FOOTER //
// src/client/helpers/prismicHelpers/prismic-custom-helpers/ForumPageHelper.js